// extracted by mini-css-extract-plugin
export var arrows = "_1w-5";
export var decrementer = "_1w-9";
export var disabled = "_1w-3";
export var error = "_1w-1";
export var hiddenText = "_1w-a";
export var incrementer = "_1w-8";
export var input = "_1w-7";
export var inputWrapper = "_1w-0";
export var readonly = "_1w-2";
export var regular = "_1w-6";
export var small = "_1w-4";